import { UserTypeEnum } from '@/models/User';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '@/data/hook/useAuth';
import { isStudent } from '../../functions/auth';
import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { AvatarBadge } from '@/components/ui/custom/dataDisplay/AvatarBadge';
import { RewardsView } from '@/components/ui/custom/dataDisplay/RewardsView';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import SuggestionsCard from '@/components/ui/custom/SuggestionsCard';

export default function Header() {
  const path = window.location.pathname;
  const separator = path.split('/');
  const rootUrl = '/' + separator[1];
  const { user } = useAuth();

  const { t } = useTranslation('translation', { keyPrefix: 'avatar' });
  const blockedPaths = [
    '/admin',
    '/teacher',
    '/profile',
    '/projects',
    '/class-progress',
    '/classReport',
  ];

  function hasToRenderUserAvatar() {
    if (blockedPaths.includes(rootUrl)) {
      return false;
    } else if (
      (rootUrl !== path && rootUrl !== '/courses') ||
      (rootUrl === '/courses' && !isStudent(user?.userType))
    ) {
      return false;
    } else {
      return true;
    }
  }

  return (
    <div className="absolute right-5 hidden lg:flex z-51 top-2">
      {!hasToRenderUserAvatar() ? (
        <React.Fragment />
      ) : (
        <div className="flex gap-3 items-start">
          <ConditionalRenderer
            condition={import.meta.env.MODE === 'production'}
          >
            <ComponentGuard
              roles={[
                UserTypeEnum.TEACHER,
                UserTypeEnum.SUPER_ADMIN,
                UserTypeEnum.UNIT_ADMIN,
              ]}
            >
              <SuggestionsCard />
            </ComponentGuard>
          </ConditionalRenderer>
          <RewardsView size={rootUrl === '/courses' ? 'small' : 'regular'} />
          <Tooltip text={t('profile')} color="accent">
            <ConditionalRenderer condition={user}>
              <AvatarBadge
                testId="profileAvatar"
                size={rootUrl === '/courses' ? '7' : '14'}
                user={user}
              />
            </ConditionalRenderer>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
